import React from 'react';
import { ArrowLeft, ChevronRight, SquareCheckBig, Calendar, GitFork, ShieldCheck } from 'lucide-react';
import { Drawer as TaskDrawer, DrawerContent as TaskDrawerContent } from '../../Components/UI/drawer';
import taskClassConfig from '../../Config/taskClassConfig.json';

const TaskClassSelectorDrawer = ({ open, onOpenChange, onSelectClass }) => {
  const iconMap = {
    SquareCheckBig,
    Calendar,
    GitFork,
    ShieldCheck
  };

  return (
    <TaskDrawer open={open} onOpenChange={onOpenChange}>
      <TaskDrawerContent className="p-0 [&>div:first-child]:hidden top-auto !h-auto rounded-t-[22px] max-h-[85dvh] border-t border-zinc-100 z-[10002]">
        <div className="flex flex-col bg-zinc-50 rounded-t-[22px] select-none pb-4">
          <div className="flex items-center justify-between px-4 h-16 shrink-0 rounded-t-[22px]">
            <div className="flex gap-4 items-center">
              <button
                type="button"
                tabIndex={-1}
                className="p-0 w-auto h-auto flex-shrink-0 flex justify-center text-gray-500 cursor-pointer"
                onClick={() => onOpenChange(false)}
              >
                <ArrowLeft className="h-[24px] w-[24px]" />
              </button>
              <p className="text-lg font-semibold text-gray-900">Select Action Type</p>
            </div>
          </div>

          <div className="overflow-y-auto custom-scroll flex-1 px-4 pb-1 space-y-3">
            {(taskClassConfig?.taskClasses || []).map((cls) => {
              const Icon = iconMap[cls.icon] || SquareCheckBig;
              return (
                <button
                  key={cls.id}
                  onClick={() => {
                    onOpenChange(false);
                    onSelectClass(cls.id);
                  }}
                  className="w-full flex items-center gap-4 p-3.5 bg-white border border-zinc-200 rounded-[12px] hover:bg-zinc-50 transition-all text-left cursor-pointer group active:bg-zinc-100"
                >
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 text-white transition-transform group-active:scale-95"
                    style={{ backgroundColor: cls.color }}
                  >
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-sm font-semibold text-gray-900 transition-colors">
                      {cls.label}
                    </h4>
                    <p className="text-xs text-gray-500 mt-0.5 truncate">
                      {cls.description}
                    </p>
                  </div>
                  <ChevronRight className="w-4 h-4 text-gray-400 group-hover:translate-x-0.5 transition-transform shrink-0" />
                </button>
              );
            })}
          </div>
        </div>
      </TaskDrawerContent>
    </TaskDrawer>
  );
};

export default TaskClassSelectorDrawer;
